import { ofType } from 'redux-observable';
import { exhaustMap, withLatestFrom } from 'rxjs/operators';

import {
    fetchFeatureEnrollments,
    fetchFeatureEnrollmentsSuccess,
    fetchFeatureEnrollmentsError,
} from '@perpay-web/fintech/actions/entities/featureEnrollments';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import {
    fetchFeatureEnrollmentsForPerpayPlus as fetchFeatureEnrollmentsForPerpayPlusAction,
    fetchFeatureEnrollmentsForPerpayPlusSuccess,
    fetchFeatureEnrollmentsForPerpayPlusError,
} from '@perpay-web/fintech/actions/ui/featureEnrollments';
import { getHasEverOptedInToPerpayPlus } from '@perpay-web/fintech/dataModules/fetchFeatureEnrollments';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const fetchFeatureEnrollmentsForPerpayPlus = (action$, state$) =>
    action$.pipe(
        ofType(fetchFeatureEnrollmentsForPerpayPlusAction().type),
        withLatestFrom(state$),
        exhaustMap(() =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [fetchFeatureEnrollments()],
                waitFor: [fetchFeatureEnrollmentsSuccess().type],
                waitForDispatch: (state, results) => {
                    const { payload } = results[0];
                    const hasEverOptedInToPerpayPlus =
                        getHasEverOptedInToPerpayPlus(state);
                    // only redirect if user is at the enrollment path
                    const shouldRedirect =
                        window.location.pathname === paths.perpayPlus.path;

                    const returnActions = [
                        fetchFeatureEnrollmentsForPerpayPlusSuccess(payload),
                    ];

                    if (hasEverOptedInToPerpayPlus && shouldRedirect) {
                        returnActions.push(
                            routeToLocation({
                                path: paths.dashboard.path,
                                replace: true,
                            }),
                        );
                    }

                    return returnActions;
                },
                errors: [fetchFeatureEnrollmentsError().type],
                errorDispatch: (errorAction) => [
                    fetchFeatureEnrollmentsForPerpayPlusError(
                        errorAction.payload,
                    ),
                ],
            }),
        ),
    );
